import { api } from "../utils/api";

export const ExportApi = {
  ProcessBulkExport: async (country: string, languages: string[], content: string[]): Promise<any> => {
    return await api.getFile(
      `Export/${country}/BulkExport`, 
      {languages, content},
      undefined,
      { "Accept": "application/zip" }
    );
  },
};